import React, {Component} from 'react';
import {Modal, ModalHeader, ModalBody, FormGroup, Label, Input,Button, Col, Row} from 'reactstrap';
import axios from "axios";
import {serverPath} from "../../common";

class ChangeTestCases extends Component {

    constructor(props) {
        super(props);

        this.state = {testCases: []};
    }

    handleChange = event => {
        let newFiles = Array.prototype.slice.call(event.target.files);
        let oldFiles = this.state.testCases;
        let allFiles = oldFiles.concat(newFiles);

        this.setState({testCases: allFiles});
    }

    deleteFile = index => {
        let newFiles = this.state.testCases;
        newFiles.splice(index,1);

        this.setState({testCases: newFiles});
    }

    deleteAll = () => {
        this.setState({testCases: []});
    }

    saveChanges = () => {
        var formData = new FormData();

        var filesNum = this.state.testCases.length;
        for( var i=0; i<filesNum; i++) {
            formData.append('testCases[]', this.state.testCases[i]);
        }
        formData.append('problem', JSON.stringify(this.props.problem));
        formData.append('action', 'updateTestCases');

        axios.post(serverPath + "problemsService.php", formData)
            .then((response) => {
                if(response.data)
                    alert("Test primeri su uspešno zamenjeni");
                else
                    alert("Do[lo je do greške pri zameni test primera.");
            });
    }

    render() {
        let fileList = this.state.testCases.map((el, index) => {
            return (<p>
                <span className="fa fa-remove mr-2" onClick={() => this.deleteFile(index)}> </span> | {el.name}
            </p>);
        });

        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.closeModalHandler}>
                <ModalHeader toggle={this.props.closeModalHandler}>
                    <h4> Izmena test primera </h4>
                </ModalHeader>
                <ModalBody className="">
                    <div>
                        <FormGroup>
                            <Label for="fileUpload">Izaberite test primere</Label>
                            <Input type="file"
                                   name="testCases"
                                   id="fileUpload"
                                   multiple
                                   onChange={this.handleChange}/>
                        </FormGroup>
                        <FormGroup>
                            <Label> Izabrani fajlovi: </Label>
                            {fileList}
                        </FormGroup>
                        <Row>
                            <Col>
                            <Button onClick={this.deleteAll}> <span className="fa fa-remove mr-2"> </span> Obriši izabrane fajlove </Button>
                            </Col>
                            <Col>
                            <Button onClick={this.saveChanges} color="success"> Sačuvaj promene </Button>
                            </Col>
                        </Row>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}

export default ChangeTestCases;